import { AnimatePresence, motion, useAnimation } from "framer-motion";
import React, { useEffect } from "react";
import Helmet from "react-helmet";
import Layout from "../../components/layout";

export default ({ data }) => {
  const controls = useAnimation();

  useEffect(() => {
    controls.start((i) => ({
      opacity: 1,
      x: 0,
      z: 4,
      y: 0,
      transition: { delay: i * 0.08 },
    }));
  }, []);

  const handleBack = () => {
    if (typeof window !== "undefined") window.history.back();
  };

  return (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Eduardo Trevino - {data.title}</title>
      </Helmet>

      

      <div className="h-full w-full flex flex-col lg:flex-row p-4 ">
        {/* Text Section */}

        {/* Back Button */}
        <div className="p-4">
          <button
            onClick={handleBack}
            className="bg-transparent text-white px-4 py-2 rounded border border-transparent hover:border-white transition-colors duration-200"
          >
            ← Back
          </button>
        </div>

        <div className="flex-1 flex flex-col justify-center p-2">
          <motion.div
            custom={1}
            animate={controls}
            className="text-6xl font-extrabold"
            style={{ opacity: 0, x: -10 }}
          >
            {data.title}
          </motion.div>
          <br />
          <motion.div
            custom={1}
            animate={controls}
            style={{ opacity: 0, x: -10 }}
            className="text-xl font-thin"
          >
            {data.description}
          </motion.div>
          <br />
          <motion.div
            custom={2}
            animate={controls}
            style={{ opacity: 0, x: -10 }}
            className="text-xl font-thin"
          >
            <b>Technology</b> : {data.technology.join(", ")}
          </motion.div>
          <motion.div
            custom={3}
            animate={controls}
            style={{ opacity: 0, y: -10 }}
            className="flex flex-wrap gap-2"
          >
            {data.link.map((e, idx) => (
              <a
                key={idx}
                href={e.url}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 border border-white hover:border-[#243c5a] rounded text-sm"
              >
                {e.text}
              </a>
            ))}
          </motion.div>
        </div>

        {/* Image Section */}
        <AnimatePresence>
          <motion.div
            layoutId={data.slug}
            className="flex-1 flex justify-center items-center hide-scrollbar"
          >
            <img
              src={data.image}
              className="w-3/4 rounded-xl object-contain"
            />
          </motion.div>
        </AnimatePresence>
      </div>
    </Layout>
  );
};
